module.exports = __webpack_public_path__ + "static/whatever-101-still.90e51201.png";


//////////////////
// WEBPACK FOOTER
// /tmp/build_2cb81483/src/assets/images/home/whatever-101-still.png
// module id = 1272
// module chunks = 4 5